import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'María',
  city: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Lucía',
  city: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Valentina',
  city: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Carolina',
  city: 'Mendoza',
  time: 'hace 11 minutos'
}, {
  name: 'Florencia',
  city: 'La Plata',
  time: 'hace 14 minutos'
}, {
  name: 'Sofía',
  city: 'Mar del Plata',
  time: 'hace 17 minutos'
}, {
  name: 'Agustina',
  city: 'San Juan',
  time: 'hace 22 minutos'
}, {
  name: 'Camila',
  city: 'Tucumán',
  time: 'hace 26 minutos'
}];
export function RecentPurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showFirst = setTimeout(() => setVisible(true), 4000);
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex(i => (i + 1) % purchases.length);
        setVisible(true);
      }, 600);
    }, 8000);
    return () => {
      clearTimeout(showFirst);
      clearInterval(cycle);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const p = purchases[index];
  return <div className={`fixed bottom-24 sm:bottom-6 left-4 sm:left-6 z-40 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-25">
      <div className="bg-white rounded-2xl shadow-2xl border border-sand-200 p-4 pr-10 max-w-xs flex items-center gap-3 relative" data-id="element-26">
        <div className="w-10 h-10 rounded-full bg-sage-100 flex items-center justify-center flex-shrink-0" data-id="element-27">
          <ShoppingBag className="w-5 h-5 text-sage-600" data-id="element-28" />
        </div>
        <div className="text-sm" data-id="element-29">
          <p className="font-semibold text-earth-900" data-id="element-30">
            {p.name} de {p.city}
          </p>
          <p className="text-earth-600 text-xs" data-id="element-31">acaba de comprar el bundle</p>
          <p className="text-earth-400 text-xs" data-id="element-32">{p.time}</p>
        </div>
        <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-earth-400 hover:text-earth-700" aria-label="Cerrar" data-id="element-33">
          <X className="w-4 h-4" data-id="element-34" />
        </button>
      </div>
    </div>;
}